const $ = require('jquery');
const _ = require("underscore");
require("./webhookLookup.less");

import render from "../../utilities/render";
import run from '../../utilities/run';
import LookupTable from "../../components/lookupTable/index";
const modalAlertHtml = require("../../components/SubmitModalFlow/html/alertModal.html");
import { actionOptions } from "./filter/actionOptions.js";
import { SUCCESS_MODAL_TIMEOUT } from "../../constants";
import { prepareDataToSendController, doAjax, isOnlyLookupDataUpdate } from "../../utilities/filtersutil";
import { isNullOrUndefined, isUndefined } from "util";
import { isBlank } from "../../utilities/general";
import { setElementsFromScope } from '../../utilities/selectorHelpers';
import { createPreventDefault } from '../../utilities/general';
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT } from "../../constants";
import {handleCustomDropdownEvents} from "../../utilities/customBootstrapDropdowns";

let actionCellDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html');
let actionCellDropdownItemTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html');
let editWebhookLinkHtml = require("./html/editWebhookLink.html");
const addWebhookModalHtml = require("./html/addWebhookModal.html");
const modalHtml = require('../../sharedHtml/modal.html');


const targetSelector = "#webhook-lookup";
const notificationMode = "Webhook";
const newWebhookIdMsg = "An ID will be generated after adding the webhook";
let actionList = actionOptions;
let editedLookupRowIndex;

const savedViews = [
    {
        title: "All Webhooks",
        target: "allWebhooks",
        active: true,
        canRemove: false,
        canEdit: false,
        filters: [],
        columns: []
    }
];

let els = {};
const elsModal = {};
const elsMap = {
    addWebhookBtn: ".add-webhook-btn",
    editWebhookBtn: ".edit-webhook-btn"
}
const elsModalMap = {
    addWebhookModalFlowBtn: ".add-webhook-modal-btn",
    addWebhookEventType: "#webhook-event-type",
    addWebhookId: "#webhook-unique-id",
    addCallbackUrl: "#callbackUrl",
    addSecretkey: "#secretkey",
    webhookExistsMsg: "#dup-webhook",
    webhookEventErrMsg: "#eventtype-dropdown-error",
    webhookCallbackURlErrMsg: "#callbackurl-error",
    editWebhookModalFlowBtn: ".edit-webhook-modal-btn",
    webhookHelpCenterPage: "#redirectWebhookHelpcenterpage",
    saveWebhookBtn: ".save-webhook-btn"
};

let addWebhookModal, webhookModalSubmitFlow, testSubmitModal, failureAlertModal;

run(targetSelector, (mainEl) => {

    const dataTableComponentData = mainEl.data("webhooks");
    const filterWebhooksUrl = mainEl.data("filter-webhooks-url");
    const addWebhookSaveURL = mainEl.data("add-webhook-url");
    const eventTypesList = mainEl.data('event-types');
    const webhookHelpCenterUrl = mainEl.data("help-center-url");
    const changeStatusURL = mainEl.data("update-webhook-status");
    const webhookPingURL = mainEl.data("webhook-ping");
    const editWebhookSaveURL = mainEl.data("editsave-webhook-url");
    

    let webhookLookup = new LookupTable({
        // REQUIRED - Set a target element
        target: $("#webhook-lookup-wrapper"),
        // Set a target class for min width, needs to be a "til-x" class so it doesn't interfere with mobile widths
        minWidthClass: "q-min-width-sm-til-md",
        // REQUIRED - Set which data should be visible for mobile
        mobileColumns: [

            {
                data: "id",
                title: "Webhook ID",
                orderable: true,
            }
        ],
        tableSearch: false,

        newSavedViews: false,
        // OPTIONAL: Set Saved View Array
        savedViews: savedViews,
        bulkSelect: false,
        // REQUIRED - Data Table specific settings
        dataTable: {
            // use same settings you would if you were just calling a dataTable normally
            data: dataTableComponentData.content,
            // Not required, just to show you can
            columnDefs: [
                { className: "custom-class", targets: [1] }
            ],
            // Not required, just to show you can
            order: [
                [2, 'asc'],
            ],
            columns: [
                {
                    data: "status",
                    title: "Actions",
                    orderable: true,
                    render: renderActionWrap,
                    class: 'dtc-action-column'
                },
                {
                    data: "id",
                    title: "Webhook ID",
                    render: webhookIdActionBtns,
                    class: 'dtc-min-width-sm'
                },
                {
                    data: "eventName",
                    title: "Webhook Event",
                    class: 'dtc-min-width-sm'
                },
                {
                    data: "url",
                    title: "URL",
                    class: 'dtc-min-width-md'
                },
                {
                    data: "status",
                    title: "Status",
                    render: renderStatusPill,
                    class: 'dtc-min-width-sm'
                },
                {
                  data: "modifiedDate",
                  title: "Connection Status",  
                  render:renderModifiedDate,                
                  class: 'dtc-min-width-lg'
              }
            ]
        },

        paginationData: dataTableComponentData.page,
        onFetch: function () {
            let currentData = webhookLookup.generateData();     
            webhookLookup.showLoadingOverlay();
            //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
            if (isOnlyLookupDataUpdate(currentData)) {
                setTimeout(() => {
                    doAjax({ url: filterWebhooksUrl, success: filterSuccess, error: error, data: prepareDataToSendController(currentData) });
                }, SUCCESS_MODAL_TIMEOUT);
            }
        }
    });
    webhookLookup.init();
    var table = $("#webhook-lookup-wrapper .data-table-component").DataTable();
    handleCustomDropdownEvents();

    function filterSuccess(data) {
        let webhooks = data.content;
        let page = data.page;
        webhookLookup.setNewData(webhooks);
        webhookLookup.setPaginationData(page);
        webhookLookup.hideLoadingOverlay();
    }

    function error() {
        webhookLookup.hideLoadingOverlay();
    }


    function renderActionWrap(data, type, row, meta) {
        let newRender;
        let statusTarget = actionList[data];
        newRender = render(
            actionCellDropdownTemplate, {
                list: renderActionCellList(statusTarget),
                index: meta.row
            }
        );
        return newRender;
    };
    function renderActionCellList(list, data, row) {
        let renderedList;
        renderedList = _(list).map((item) => {
            return render(
                actionCellDropdownItemTemplate, {
                    icon: item.icon,
                    title: item.title,
                    cls: item.cls,
                    disabled: false
                }
            );
        });
        return renderedList.join('');
    }


    function renderStatusPill(data, type, row) {
        if (data === 'true') {
            return "<div class='q-marg-all-xs-at-md q-block q-pill q-pill-blue '>Active</div>";
        } else {
            return "<div class='q-marg-all-xs-at-md q-block q-pill q-pill-light-grey'>Inactive</div>";
        }
    }


    
    function renderModifiedDate(data, type, row) {
        if (isNullOrUndefined(data)) {
            return "";
        } else if(data.includes("Successful") || data.includes("Failed") ) {
            return data;
        } else {
            return `Last Update:`+ data;
        }
    }

    function init() {
        generateModals();
        setElementsInModals();
        setElements();
        loadDropDowns();
        bindElements();
    }

    function setElements() {
        setElementsFromScope(els, elsMap, mainEl);
    }

    function setElementsInModals() {
        const body = $('body');
        setElementsFromScope(elsModal, elsModalMap, body);
    }

    function bindElements() {
        //click btn on lookup
        els.addWebhookBtn.click(createPreventDefault(showAddWebhookModal));

        //click addwebhook btn on Modal
        elsModal.addWebhookModalFlowBtn.click(createPreventDefault(webhookModalFlow));
        //click save btn on Modal
        elsModal.editWebhookModalFlowBtn.click(createPreventDefault(editWebhookModalFlow))
        //click link on Modal
        elsModal.webhookHelpCenterPage.click(createPreventDefault(openHelpCenterPage));
        elsModal.addCallbackUrl.on("blur", hideErrorMsg);
        elsModal.addWebhookEventType.on("change", hideEventErrMsg);

        //On clicking the webhookID column link on lookup, show edit modal/popup 
        $('body').on('click', '.edit-webhook-btn', function(e) {
            e.preventDefault();
           
           //Get index of row clicked 
           editedLookupRowIndex = $(this).attr("id");
           // Get the row based on the parent...
           let parent = $(".dropdown-parent-" + editedLookupRowIndex).parents('tr');
           // Get the row data
           let row = $(".data-table-component").dataTable().api().row(parent);
           
           showAddWebhookModal("EDIT",row.data());
          });


        $('body').on('click', '.deactivate-webhook', function (e) {
            e.preventDefault();
            let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
            // Get the row based on the parent...
            let parent = $(".dropdown-parent-" + pIndex).parents('tr');
            // Get the row data
            let row = table.row(parent);
            var submitModalFlow = new SubmitModalFlow({
                confirmModalTitle: 'Deactivate Webhook',
                modalDialogClass: "q-modal-dialog-500",
                confirmModalBody: `<div class="q-pad-all-xl">Once deactivated, this connection will no longer be synced with your system. It can be activated at any time.</div>`,
                confirmModalBtnText: 'Deactivate Webhook',
                onConfirmClick: function () {
                    submitModalFlow.showLoadingModal();
                    deactivateWebhook(row, row.data());
                    function deactivateWebhook(row, webhook) {
                        $.ajax({
                            url: changeStatusURL,
                            type: 'POST',
                            dataType: 'JSON',
                            data: {
                                webhookId: webhook.id,
                                status: webhook.status                                
                            },
                            success: function (data) {                                            
                                if (data.responseStatus === "Success") {
                                    var d = row.data();
                                    d.id=$.trim(data.id);
                                    d.status=$.trim(data.status);
                                    d.eventName=data.eventName;
                                    d.modifiedDate = data.modifiedDate;
                                    d.url=$.trim(data.url);
                                    row.data(d).draw();
                                    submitModalFlow.showSuccessModal();
                                    setTimeout(function () {
                                        submitModalFlow.hideAllModals();                                        
                                    }, window.constants.SUCCESS_MODAL_TIMEOUT);
                                } else {
                                    submitModalFlow.showFailureModal();
                                }
                            },
                            error: function (data) {
                                submitModalFlow.hideAllModals();
                            }
                        });
                    };
                }
            });
            submitModalFlow.init();
            submitModalFlow.showConfirmModal();
        });

        //Activate Webhook 
        $('body').on('click', '.activate-webhook', function (e) {
            e.preventDefault();
            let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
            // Get the row based on the parent...
            let parent = $(".dropdown-parent-" + pIndex).parents('tr');
            // Get the row data
            let row = table.row(parent);
            var submitModalFlow = new SubmitModalFlow({
                confirmModalTitle: 'Activate Webhook',
                modalDialogClass: "q-modal-dialog-500",
                confirmModalBody: `<div class="q-pad-all-xl">Once activated, this connection will begin syncing with your system. It can be deactivated at any time.</div>`,
                confirmModalBtnText: 'Activate Webhook',
                onConfirmClick: function () {
                    submitModalFlow.showLoadingModal();
                    activateWebhook(row, row.data());
                    function activateWebhook(row, webhook) {
                        $.ajax({
                            url: changeStatusURL,
                            type: 'POST',
                            dataType: 'JSON',
                            data: {
                                webhookId: webhook.id,
                                status: webhook.status
                            },
                            success: function (data) {                              
                                if (data.responseStatus === "Success")  {
                                    var d = row.data();
                                    d.id=$.trim(data.id);
                                    d.status=$.trim(data.status);
                                    d.eventName=data.eventName;
                                    d.modifiedDate = data.modifiedDate;
                                    d.url=$.trim(data.url);
                                    row.data(d).draw();
                                    submitModalFlow.showSuccessModal();
                                    setTimeout(function () {
                                       submitModalFlow.hideAllModals();                                      
                                    }, window.constants.SUCCESS_MODAL_TIMEOUT);
                                } else {
                                    submitModalFlow.showFailureModal();
                                }
                            },
                            error: function (data) {
                                submitModalFlow.hideAllModals();
                            }
                        });
                    };
                }
            });
            submitModalFlow.init();
            submitModalFlow.showConfirmModal();
        });

        //Ping Webhook 
        $('body').on('click', '.test-connection-webhook', function (e) {
            e.preventDefault();
            let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
            // Get the row based on the parent...
            let parent = $(".dropdown-parent-" + pIndex).parents('tr');
            // Get the row data
            let row = table.row(parent);
            testSubmitModal.showLoadingModal();            
            pingWebhook(row, row.data());
            function pingWebhook(row, webhook) {
                        $.ajax({
                            url: webhookPingURL,
                            type: 'POST',
                            dataType: 'JSON',
                            data: {
                                webhookId: webhook.id,
                                status: webhook.status,
                                webhookUrl: webhook.url                         
                            },
                            success: function (data) {                       
                                if (data.responseStatus === "Success")  {
                                    var d = row.data();                                  
                                    d.id=$.trim(data.id);
                                    d.status=$.trim(data.status);
                                    d.eventName=data.eventName;
                                    d.modifiedDate =  `Successful. Last Update:`+ data.modifiedDate;     
                                    d.url=$.trim(data.url);
                                    row.data(d).draw();
                                    testSubmitModal.showSuccessModal();
                                    setTimeout(function () {
                                        testSubmitModal.hideAllModals();                                      
                                    }, window.constants.SUCCESS_MODAL_TIMEOUT);
                                }  else if(data.responseStatus === "Failed") {
                                    var d = row.data();                                  
                                    d.url=$.trim(data.url);                                   
                                    d.modifiedDate =  `Failed. Last Update:`+ data.modifiedDate                                   
                                    row.data(d).draw();
                                      setTimeout(() => {
                                        testSubmitModal.hideAllModals();
                                        failureAlertModal.modal("show");
                                      }, 2000);
                                      setTimeout(() => {
                                        failureAlertModal.modal("hide");
                                      }, 4000);
                                }   
                            },
                            error: function (data) {
                                testSubmitModal.showFailureModal();
                                setTimeout(function () {
                                    testSubmitModal.hideAllModals();                                      
                                }, window.constants.SUCCESS_MODAL_TIMEOUT);  
                               
                
                            }
                        });
            };
        });

    }

    function openHelpCenterPage() {
        window.open(webhookHelpCenterUrl);
    }

    function loadDropDowns() {
        $(eventTypesList).each(function () {
            const option = $('<option />');
            option.attr('value', this.cdmValue).text(this.cdmValue);
            elsModal.addWebhookEventType.append(option);
        });
    }

    function hideErrorMsg() {
        const callBackUrl = elsModal.addCallbackUrl.val();
        elsModal.webhookExistsMsg.hide();

        if (!isNullOrUndefined(callBackUrl) || !isBlank(callBackUrl)) {
            elsModal.webhookCallbackURlErrMsg.hide();
        }
    }

    function hideEventErrMsg() {
        const eventtype = elsModal.addWebhookEventType.val();

        if (!isNullOrUndefined(eventtype) || !isBlank(eventtype)) {
            elsModal.webhookEventErrMsg.hide();
        }
    }

    function generateModals() {

        webhookModalSubmitFlow = new SubmitModalFlow();
        webhookModalSubmitFlow.init();

        testSubmitModal = new SubmitModalFlow();
        testSubmitModal.init();

        //addWebhook modal
        addWebhookModal = $(render(
            modalHtml, {
                title: 'Add Webhook',
                footerBtns: '<a href="#" class="base-btn purple-btn v2-btn cancel-add-webhook-btn modal-auto-hide">Cancel</a>\
              <a href="#" class="base-btn purple-btn add-webhook-modal-btn">Add Webhook</a> <a href="#" class="base-btn purple-btn edit-webhook-modal-btn">Save</a>',
                body: addWebhookModalHtml,
                topCloseBtn: true,
                autoHideTop: true,
                leftAlignTitle: true,
                modalDialogClass: "q-modal-dialog-800"
            }
        ));

            //failureModal
        failureAlertModal = $(render(
            modalAlertHtml,
            {
            title: 'Failure',
            body: '<div class="q-pad-all-xl"><i class="fa fa-times-circle-o q-fa-fail fa-4x"></i></div>'
            }
        ));

        $('body').append(addWebhookModal, failureAlertModal);
    }

    /**
     * This function will show the add/edit webhook popup.
     * Resets the fields, hides all errors on popup.
     */
    function showAddWebhookModal(modalaction,selectedrowdata) {
        resetModalFields();
        elsModal.webhookExistsMsg.hide();
        elsModal.webhookEventErrMsg.hide();
        elsModal.webhookCallbackURlErrMsg.hide();
        
        if(isBlank(modalaction)){
            $("h4.q-modal-title").text("Add Webhook");            
            $("div.webhook-unique-id").text(newWebhookIdMsg);
            elsModal.addWebhookModalFlowBtn.show();
            elsModal.editWebhookModalFlowBtn.hide();
        }else if(!isBlank(modalaction)&& modalaction == 'EDIT'){
            $("h4.q-modal-title").text("Edit Webhook");
            elsModal.editWebhookModalFlowBtn.show();
            elsModal.addWebhookModalFlowBtn.hide();
            elsModal.addWebhookEventType.val(selectedrowdata.eventName).trigger('change');
            elsModal.addCallbackUrl.val(selectedrowdata.url);
            elsModal.addSecretkey.val(selectedrowdata.signature);
            $("div.webhook-unique-id").text(selectedrowdata.id);
            elsModal.addWebhookEventType.prop('disabled', true);
        }        
        addWebhookModal.modal("show");
    }

    //for subscribe modal submitflow
    function webhookModalFlow() {
        validateAddUpdateInputs("ADD");
    }

    function editWebhookModalFlow(){
        validateAddUpdateInputs("EDIT");
    }

    function validateAddUpdateInputs(action) {
        let webhookId = $("div.webhook-unique-id").text(); 
        let webhookEvent = elsModal.addWebhookEventType.val();
        let webhookUrl = elsModal.addCallbackUrl.val();
        let webhookSecretKey = elsModal.addSecretkey.val();

        if (webhookId.length == 0 || action == "ADD") {
            webhookId = null;
        }

        elsModal.webhookEventErrMsg.hide();
        elsModal.webhookCallbackURlErrMsg.hide();

        //Make sure required field values are provided.

        if (isNullOrUndefined(webhookEvent) || isBlank(webhookEvent)) {
            elsModal.webhookEventErrMsg.show();
        }

        if (isNullOrUndefined(webhookUrl) || isBlank(webhookUrl)) {
            elsModal.webhookCallbackURlErrMsg.show();
            return false;
        } else {
            webhookModalSubmitFlow.showLoadingModal();
            subscribeNewWebHook(webhookId, webhookEvent, webhookUrl, webhookSecretKey,action);
        }
    }

    function subscribeNewWebHook(webhookId, webhookEvent, webhookUrl, webhookSecretKey,modalAction) {
        let saveURL = addWebhookSaveURL;
        if(!isBlank(modalAction) && modalAction =="EDIT"){
          saveURL = editWebhookSaveURL;              
        }
        
        $.ajax({
            url: saveURL,
            data: {
                addNopId: webhookId,
                addNopNotificationEvent: webhookEvent,
                addNopNotificationTo: webhookUrl,
                addNopNotificationMode: notificationMode,
                addNopSecretKey: webhookSecretKey
            },
            dataType: "JSON",
            type: 'POST',
            success: function (data) {
                if ((data.status).toLowerCase() == "success") {
                    addWebhookModal.modal("hide");
                    webhookModalSubmitFlow.hideAllModals();
                    webhookModalSubmitFlow.showSuccessModal();
                    if(modalAction == 'EDIT'){
                        // Get the row based on the parent...
                        let parent = $(".dropdown-parent-" + editedLookupRowIndex).parents('tr');

                        // Get the row data
                        let row = table.row(parent);
                        
                        //display updated data in lookup row
                        var rowObj = row.data();
                        rowObj.id=$.trim(webhookId);
                        rowObj.url=$.trim(webhookUrl);
                        rowObj.signature=$.trim(webhookSecretKey);
                        row.data(rowObj).draw();
                        
                        setTimeout(function () {
                                webhookModalSubmitFlow.hideAllModals();                                      
                        }, window.constants.SUCCESS_MODAL_TIMEOUT);

                    }else{
                        //for ADD reload screen
                        webhookModalSubmitFlow.hideAllModals();
                        setTimeout(function () {
                            location.reload();
                        }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
                    }                    
                }
                else {
                    webhookModalSubmitFlow.hideAllModals();
                    if (data.errors != undefined && (data.errors).length >0 && ((data.errors)[0].code) == "ERR-WHK-0009") {
                        addWebhookModal.modal("show");
                        elsModal.webhookExistsMsg.show();
                    } else if (data.errors != undefined) { 
                        //incase of any other errors show generic failure modal
                        addWebhookModal.modal("show");
                        if(data.errors != undefined && (data.errors).length >0){
                            webhookModalSubmitFlow.setErrors({
                                errorDescription: (data.errors)[0].description                            
                            });
                        }                        
                        webhookModalSubmitFlow.showFailureModal();
                    }
                }
            }
        });
    }

    //This function clears the field values on Add/Edit popup
    function resetModalFields() {
        elsModal.addWebhookEventType.prop('disabled', false); 
        elsModal.addWebhookEventType.val("").trigger('change');
        elsModal.addCallbackUrl.val("");
        $("div.webhook-unique-id").text(newWebhookIdMsg);
        elsModal.addSecretkey.val("");
    }

    //for rendering WebhookID column as link on lookup table
    function webhookIdActionBtns(data, type, row,meta) {
      return render(
        editWebhookLinkHtml,
        {
          webHookClassName: data,
          index: meta.row
        }
      );      
    }

    init();

});


// WEBPACK FOOTER //
// ./src/pages/webhooks/lookup.js